import { PlanNames } from '../planNames';
import { StripePricesLookupKeys } from './stripeConfig';
// For migration period
export const priceToLookupMap = {
    [PlanNames.Mini]: StripePricesLookupKeys.Essentials50,
    [PlanNames.Starter]: StripePricesLookupKeys.Essentials150,
    [PlanNames.Professional]: StripePricesLookupKeys.Pro300,
    [PlanNames.Multi]: StripePricesLookupKeys.Pro600,
    [PlanNames.MultiPlus]: StripePricesLookupKeys.Pro1000,
    [PlanNames.Multi3000]: StripePricesLookupKeys.Pro2000,
    // Legacy
    [PlanNames.LegacyLite]: StripePricesLookupKeys.Essentials150,
    [PlanNames.LegacyStarter]: StripePricesLookupKeys.Pro300,
    [PlanNames.LegacyStandard]: StripePricesLookupKeys.Pro600,
    [PlanNames.LegacyUnlimited]: StripePricesLookupKeys.Pro1000,
    [PlanNames.LegacyPro]: StripePricesLookupKeys.Pro2000,
};
//# sourceMappingURL=priceToLookupMap.js.map